import { Service } from '@angular/core';
import { User } from '@common/users/models/user.model';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: UsersState
})
@State<UsersState>({
  name: UsersState.source
})
@Service({ autoProvided: false })
export class UsersState extends CollectionStateBase {
  static override source: string = 'Users';

  getSource(): string {
    return UsersState.source;
  }
}

@Service()
export class UsersDataService extends CollectionDataServiceBase<User> {
  protected readonly stateType = UsersState;
}
